<template>
  <div class="bottom">
    <div class="TL">
      <img class="logoDa" src="~@/assets/img/logoBai.png">
      <p class="logoP">官方其他业务</p>
      <div class="logoD">
        <img src="~@/assets/img/logo3.png">
        <img src="~@/assets/img/logo2.png">
      </div>
    </div>
    <div class="TR">
      <div>
        <img src="~@/assets/img/er.png">
        <p>客服微信</p>
      </div>
      <div>
        <img src="~@/assets/img/er.png">
        <p>关注我们</p>
      </div>
    </div>
    <div class="TB">
      <p><span>24h热线：400-805-0105</span>地址：北京市大兴区星光视界中心3号楼C座1003</p>
      <p><span>西北运营中心：17809940906</span>地址：新疆恒成星信息技术咨询服务有限公司</p>
    </div>
    <div class="BB">
      <p>@2012-2032 瀚礼网 隶属于北京赛兰科贸有限公司版权所有，</p>
      <p>并保留所有权限。  京IPC备16046752号-2</p>
    </div>
  </div>
</template>


<script>
export default {
  name: 'bottom',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
.bottom
  width 100%
  background #323232
  display flex
  flex-flow row wrap
  padding-top px(30)
  .TL
    width 44%
    border-right 1px solid #585858
    padding 0 px(30)
    .logoDa
      width px(138)
    .logoP
      font-size px(20)
      color #fff
      height px(68)
      line-height px(68)
    .logoD
      display flex
      img
        width px(113)
        margin-right px(11)
  .TR
    width 56%
    display flex
    justify-content end
    padding 0 px(30)
    div
      margin-left px(62)
    img
      width px(129)
    p
      font-size px(20)
      color #939393
      height px(46)
      line-height px(46)
      text-align center 
  .TB
    padding 0 px(30)
    p
      font-size px(20)
      color #939393
      text-align center
    span
      margin-right px(10)
  .BB
    width 100%
    background #212121
    p
      color #939393
      font-size px(20)
      text-align center
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue